import { Region } from '@klp/portfolio/classes/Region';

import { useSelector } from 'react-redux';
import { ContractLinesDateRange } from '../classes/ContractLinesDateRange';
import type { IContextSelectorState } from '@klp/contextSelector';
import { contextSelectors } from '@klp/contextSelector';
import type { ExpiryTypeList } from '../classes/ExpiryType';
import { ExpiryType } from '../classes/ExpiryType';
import { AggregateRequest } from '../classes';
import { usePortfolio } from '@klp/portfolio/store';
import { useCurrentUser } from '@klp/auth';
import type { Bruker } from '@klp/user';
import { localStorageReferences } from './constants';

enum FrontpageCardTypes {
    UTESTAAENDE_FORDRINGER = 'utestaaendeFordringer',
    AREALMESSIG_UTLEIEGRAD = 'arealmessigUtleiegrad',
    KONTRAKTER = 'kontrakter',
    PROSJEKTER = 'prosjekter',
    SAKER = 'saker',
    LEVERANDOR = 'leverandor',
}

const getDefaultExpiryType = (user: Bruker | undefined): ExpiryTypeList => {
    if (!user) return ExpiryType.list.expires_within_6m;
    if (user.isHandelForvalter) return ExpiryType.list.expires_within_6m;
    if (user.isKontorForvalter) return ExpiryType.list.expires_within_4y;

    return ExpiryType.list.expires_within_4y;
};

// Finner ut gjeldende verdier for forvalter, region, byggnummer og utløpsdatoer - oversettelse av saga logikk
const useFetchFrontpageAggregatesRequest = (
    initialExpiryType?: ExpiryType,
    initialPortfolio?: string,
    initialRegion?: Region,
    initialSelectedContext?: IContextSelectorState,
) => {
    const { currentUser, isEDAdmin } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);
    const { portfolio } = usePortfolio();

    const expiryType = initialExpiryType ?? getDefaultExpiryType(currentUser);

    let currentPortfolio: string | undefined;
    let currentRegion: Region;

    currentPortfolio = !currentUser?.region ? currentUser?.epost : '';
    currentRegion = currentUser?.region
        ? new Region({ name: currentUser?.region })
        : Region.empty();

    if (isEDAdmin) {
        currentPortfolio = !portfolio?.region
            ? (portfolio?.brukerId ?? '')
            : '';
        currentRegion = portfolio?.region
            ? new Region({ name: portfolio?.region })
            : Region.empty();
    }

    const range = ContractLinesDateRange.fromExpiryType(expiryType);
    const from = range.fromDateFormatted();
    const to = range.toDateFormatted();
    const derivedRegion = initialRegion?.name ?? currentRegion?.name;
    const forvalter = initialPortfolio ?? currentPortfolio;
    const byggNummer =
        initialSelectedContext?.selectedContext?.nummer ??
        selectedContext?.nummer;

    return {
        frontpageAggregateRequest: new AggregateRequest({
            from,
            to,
            region: !byggNummer ? derivedRegion : '',
            forvalter: !byggNummer ? forvalter : '',
            byggNummer: byggNummer ?? '',
            filtrerPaaFavoritter: !byggNummer,
        }),
    };
};

export {
    localStorageReferences,
    FrontpageCardTypes,
    useFetchFrontpageAggregatesRequest,
    getDefaultExpiryType,
};
